import React from 'react';
import './ScimitarLogo.css';

const ScimitarLogo = () => {
  return (
    <div className="scimitar-logo">
      <img 
        src="/images/scimatar-wht.png" 
        alt="Scimitar Logo" 
        className="logo-image"
      />
    </div>
  );
};

export default ScimitarLogo; 